/*
 * Returns a div with an <input> for each attribute
 * defined in the layer's "attributes" property.
 * Each input's initial value is set to the feature's attrib value.
 * The feature's attrib value is updated when the input's value is changed.
 */

/* global isNumber */

// import {selectedFeatures} from './selectedFeatures.js';
import collapsable from './collapsable.js';

/**
 * called like:
 *    attribElement.appendChild(editableAttributes(feature));
 * returns the whole attrib div
  */

export default function(feature) {
  // layer name 'wfs' is hard coded here - not good!
  let attributeList
  /* // only one editable, saveable layer
  let editLayer = rwg.map.getLayerByTitle(rwg.config.editable);
  if (editLayer?.getVisible()) {
    attributeList = editLayer.getSource().get('attributes')
  }
  */
  // 2022-05-01 rwg.config.editable can be a comma separated list of layers
  // this accommodates multiple layers that share a common source but
  // could be a source of error if there are multiple saveable sources
  if (rwg.config.editable) {
    let editableLayers = rwg.config.editable.split(',');
    editableLayers.forEach(lyr => {
      lyr = lyr.trim()
      let editLayer = rwg.map.getLayerByTitle(lyr)
      if (editLayer?.getVisible()) {
        attributeList = editLayer.getSource().get('attributes')
      }
    })
  }

  attributeList = attributeList || ['label']; // "label" could be a default attribute of "lyrDraw" source

  let div = document.createElement('div');
  div.className = 'justified-labels';

  attributeList.forEach(function(attribute) {
    if (attribute.indexOf('_') === 0) { // underscore prefix indicates a joined table
      let joinedTableName = attribute.substring(1); // 2023-12-30 switched from substr() to substring()
      let joinedTableData = feature.get(attribute);
      // let joinedTableDiv = document.createElement('div'); // the top level div for this joined-table attribute class

      // If there's no selectedFeature then it's probably a newly created feature and
      // this function  is being called from the initial attribute creation dialog.
      // We don't want a "new" button for joined tables in the attribute creation dialog.
      // if (selectedFeatures.get().length > 0) {
      if (rwg.selection.selectInteraction.getFeatures().getLength() > 0) {
        // let joinedTableDivId = `div-${joinedTableName}`; // container for nesting multiple joined rows from same table and a "create new" button
        // joinedTableDiv.id = joinedTableDivId;
        // joinedTableDiv.style.marginLeft = '2em';
        // joinedTableDiv.appendChild(newJoinedTableBtn(`${joinedTableName}`));  // should add number of rows here: joinedTableData

        // // if the joined table has a pk then there's an existing record
        if (joinedTableData && joinedTableData[0] && joinedTableData[0].pk) {
          joinedTableData.forEach(function(attrib) {
            // function(joinedTableName, attrib, targetElement)
            // createJoinedAttribDiv(joinedTableName, attrib, joinedTableDiv); // added to container of nested rows
            createJoinedAttribDiv(joinedTableName, attrib, div); // add to top level div
          });
        }
        // //              function(label, content, expanded)
        // let tableDiv = collapsable(joinedTableName, joinedTableDiv, joinedTableData);
        // div.append(tableDiv);

      }
      // div.appendChild(joinedTableDiv);
    } else {  // single top-level attribute, not array of attribs from a joined table
      div.appendChild(
        createInput(    // createInput(key, value, handler, pk, joinedTableName)
          attribute,    // key
          feature.get(attribute),   // value
          function(val) { feature.set(attribute, val); }  // handler
        )
      );
    }
  });

  return div;


  /* *** private functions below *** */


  function createInput(key, value, handler) {
    let div = document.createElement('div');
    let label = document.createElement('label');
    let input = document.createElement('input');
    input.type = 'text';
    // let input = document.createElement('textarea');
    input.rows = 1;
    input.cols = 30;
    input.wrap = 'hard';  // wrap="hard" will contain newlines (if any) when submitted in a form
    input.style.verticalAlign = 'top';   // should go in .css file

    label.for = key;
    label.innerHTML = key;

    input.name = key;
    input.value = typeof value !== 'undefined' ? value : '' ;

    // input.setAttribute('data-pk', pk);
    input.addEventListener('input', function(evt) {
      // handler(evt.target, joinedTableName, pk); // non-joined table expects: attribute, value
      handler(this.value); // non-joined table expects: attribute, value
      // feature.set(key, this.value);
      // this should check keysToLabel so all labeled attributes updated dynamically, not just "label"
      feature.changed();  // increment to ol revision counter
      if (key === 'label') {  // nice feature that updates the label on the map as the user types
        let style = feature.getStyle();
        if (style) {
          style[0].getText().setText(this.value);
        }
      }
    });

    input.addEventListener('change', function(evt) {
      if (rwgInitParams.attribChangeHandler) rwgInitParams.attribChangeHandler(evt, feature);
    });

    div.appendChild(label);
    div.appendChild(input);
    // div.appendChild(document.createElement('br'));
    return div;
  }

  /** private function
   *  returns div of editable attributes for a single row of a joined table
   *  with a title and a delete button. The row is an array of attributes
   */
  function createJoinedAttribDiv(joinedTableName, attrib, targetElement) {
    let joinedAttribContent = document.createElement('div');

    joinedAttribContent.appendChild(deleteJoinedTableBtn(joinedTableName, attrib.pk));

    for (let key in attrib) {
      joinedAttribContent.appendChild(
        createInput(  // createInput(key, value, handler, pk, joinedTableName)
          key,
          attrib[key],
          function (val) { // eslint-disable-line ie11/no-loop-func
            let rows = feature.get('_' + joinedTableName);
            rows.forEach(function(row) { // eslint-disable-line ie11/no-loop-func
              if (row.pk == attrib.pk) {
                row[key] = val;
              }
            });
          }
        )
      );
    }
    let div = collapsable(joinedTableName + ' ' + (attrib.complete_date || '') , joinedAttribContent, true);
    div.id = joinedTableName + attrib.pk;
    targetElement.append(div);
  }

  /** private function
   *  inserts new row into a joined table on the server
   *  and adds new row to the feature
   *  returns the new row (which will have all coulmns in table, new pk, etc.)
   */
  function createJoinedRow(tableName, featureId, targetElement) {
    let payload = {
      action: 'new-joined-row',
      table: tableName,
      zones_ogc_fid: featureId
    };
    rwg.ajax( 'crud.php', {
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(payload),
      success: function(dat) {
        // need to add joined row to feature and add it to editable attributes in infotool
        dat = JSON.parse(dat);
        // console.log(dat);
        let joinedRowArray = feature.get('_' + tableName);
        if (joinedRowArray) {
          joinedRowArray.unshift(dat); // unshift() adds new item(s) to beginning of array
          // console.log(joinedRowArray);
        } else {
          feature.set('_' + tableName, [dat]);
          // console.log('no joinedRowArray');
        }
        createJoinedAttribDiv(tableName, dat, targetElement);
        // console.log(feature.get('_' + tableName));
      }
    });
  }

  function deleteJoinedRow(tableName, pk) {
    let payload = {
      action: 'delete-joined-row',
      table: tableName,
      pk: pk
    };
    rwg.ajax('crud.php', {
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(payload),
      success: function(dat) {
        if (!isNumber(dat)) { // rwg function declared in util.js
          alert(dat);
        } else if (Math.abs(dat) != pk) {
          alert('Error: returned pk not equal submitted pk!');
        } else {
          let joinedAttribDiv = document.getElementById(tableName+pk);
          joinedAttribDiv.parentNode.removeChild(joinedAttribDiv);  // annimating this removal would provide nicer user feedback
          let joinedRowArray = feature.get('_' + tableName);
          joinedRowArray.forEach((row, index) => {
            if (row.pk == pk) {
              joinedRowArray = joinedRowArray.splice(index, 1);
            }
          });
        }
      }
    });
  }

  /**
   * element is the HTML element that fired the 'change' event, probably a <textarea>
   * joinedTableName is one-to-many so may have multiple rows
   * pk is the unique id of the changed record in the joinedTable
   */

  /*
    function editJoinedRow(element, joinedTableName, pk) {
      let rows = feature.get(joinedTableName);
      rows.forEach(function(row) {
        if (row.pk === pk) {
          row[element.name] = element.value;  // element.name is the name of the field in the record that has been changed
          feature.changed();  // increment to ol revision counter
        }
      });
    }
  */





  /* *** utility functions below *** */

  // accordion buttton
  function accordionBtn(label, contentId) {

    let btn = document.createElement('button');
    btn.className = 'w3-btn w3-block w3-left-align';
    btn.style.margin = '.5em';
    btn.style.textTransform = 'capitalize';
    btn.style.width = '100%';
    btn.style.backgroundColor = 'brown';
    btn.innerText = label;
    btn.setAttribute('rwg-content-id', contentId);
    btn.addEventListener('click', function() {
      let accordionContent = document.getElementById(this.getAttribute('rwg-content-id'));
      if (accordionContent.classList.contains('w3-show')) {
        accordionContent.classList.replace('w3-show', 'w3-hide');
      } else {
        accordionContent.classList.replace('w3-hide', 'w3-show');
      }
    });
    // div.append(btn);
    // return div;
    return btn;
  }

  // buttton for creating a new row in a joined table
  function newJoinedTableBtn(joinedTableName) {
    let btn = document.createElement('button');
    // btn.className = 'rwg-btn';
    btn.style.marginLeft = '.5em';
    btn.innerText = `Create new ${joinedTableName} record`;
    btn.id = `btn-new-${joinedTableName}`;
    btn.addEventListener('click', function() {
      // createJoinedRow(joinedTableName, feature.get('ogc_fid'), this.parentElement);
      createJoinedRow(
        joinedTableName,
        feature.get('ogc_fid'),
        this.nextElementSibling || this.parentElement // parentElement if this is 1st joined rowm else nextElementSibling
      );
    });
    return btn;
  }

  // buttton for deleting a row in a joined table
  function deleteJoinedTableBtn(joinedTableName, pk) {
    let btn = document.createElement('button');
    btn.style.marginLeft = '1em';
    btn.innerText = 'Delete';
    btn.setAttribute('rwg-pk', pk);  // attach the pk to the button so we can fetch it onClick
    btn.addEventListener('click', function() {  // don't use arrow function here - need "this" within the function
      deleteJoinedRow(joinedTableName, this.getAttribute('rwg-pk'));
    });
    return btn;
  }
}
